import { EmailScannerType } from '@ViewModels';
import { css, StyleDeclaration } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../components-v2/Button';
import { ButtonGroup, ButtonGroupSeparator } from '../../components-v2/ButtonGroup';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '../../components-v2/Dropdown';
import { ChevronDown } from '../svgs/icons/ChevronDown';
import { SuccessCheckIcon } from '../svgs/icons/SuccessCheckIcon';
import { styleSheet } from './styles';

interface IProps {
	enabled?: boolean;
	id: string;
	leadsProcessed?: number;
	logo?: React.ReactNode;
	onEnableClick?(id: string, enable: boolean, type: EmailScannerType): void;
	onManageClick?(): void;
	onTestClick?(): void;
	styles?: StyleDeclaration[];
	tags?: string[];
	type?: EmailScannerType;
}

export const LeadParserCard: React.FC<IProps> = ({
	enabled = false,
	leadsProcessed = 0,
	logo,
	id,
	onEnableClick,
	onManageClick,
	onTestClick,
	styles = [],
	tags = [],
	type,
}) => {
	const onEnableParser = () => {
		onEnableClick?.(id, !enabled, type);
	};

	const onManageCtaClick = () => {
		onManageClick?.();
	};

	const onTestCtaClick = () => {
		onTestClick?.();
	};

	return (
		<div className={css(styleSheet.container, ...styles)}>
			<div>
				<div className={css(styleSheet.iconContainer)}>{logo}</div>
				<div className={css(styleSheet.numLeadsParsedContainer)}>
					{`${enabled ? `${leadsProcessed} Lead${leadsProcessed === 1 ? '' : 's'} processed` : ''}`}
				</div>
				{tags.length > 0 && (
					<div className={css(styleSheet.tagsContainer)}>
						{tags.map((tag, i) => {
							return (
								<div className={css(styleSheet.tag)} key={i}>
									{tag}
								</div>
							);
						})}
					</div>
				)}
			</div>
			<div className={css(styleSheet.controlsContainer)}>
				{enabled ? (
					<div className={css(styleSheet.enabledIndicator)}>
						<SuccessCheckIcon />
						<span>Enabled</span>
					</div>
				) : (
					<Button size='sm' variant='secondary' onClick={onEnableParser}>
						Enable
					</Button>
				)}
				{enabled && !onManageClick && (
					<Button size='sm' variant='secondary' onClick={onEnableParser}>
						Disable
					</Button>
				)}
				{onManageClick && (
					<div className={css(styleSheet.dropdownContainer)}>
						<ButtonGroup>
							<Button size='sm' onClick={onManageCtaClick}>
								Manage
							</Button>
							{onTestClick ? (
								<>
									<ButtonGroupSeparator />
									<Dropdown>
										<DropdownTrigger render={<Button size='sm' />}>
											<ChevronDown />
										</DropdownTrigger>
										<DropdownContent align='end'>
											<DropdownItem onClick={onTestCtaClick}>Test</DropdownItem>
										</DropdownContent>
									</Dropdown>
								</>
							) : null}
						</ButtonGroup>
					</div>
				)}
			</div>
		</div>
	);
};
